import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
  code: 'LLM.Provider',
})
export class LLMProvider {
  @GenericLookup({
    code: 'LLM.Provider.OpenAI',
  })
  static openAI: number;

  @GenericLookup({
    code: 'LLM.Provider.Azure',
  })
  static azure: number;

  @GenericLookup({
    code: 'LLM.Provider.PrivateLLM',
  })
  static privateLLM: number;

  @GenericLookup({
    code: 'LLM.Provider.Proxy',
  })
  static proxy: number;

  @GenericLookup({
    code: 'LLM.Provider.AwsBedrock',
  })
  static awsBedrock: number;

  @GenericLookup({
    code: 'LLM.Provider.Gemini',
  })
  static gemini: number;

  @GenericLookup({
    code: 'LLM.Provider.Groq',
  })
  static groq: number;

  @GenericLookup({
    code: 'LLM.Provider.TogetherAi',
  })
  static togetherAi: number;

  @GenericLookup({
    code: 'LLM.Provider.VertexAi',
  })
  static vertexAi: number;
}
